import { useMemo, useState } from 'react'
import { BookmarkPlus, Copy, MessageSquarePlus, Trash2 } from 'lucide-react'
import { AgentNodeToolbar, type ToolbarAction } from './AgentNodeToolbar'
import { RemoveNodeConfirmationModal } from './RemoveNodeConfirmationModal'
import { useNodeActions } from './useNodeActions'

interface UploadMediaNodeToolbarProps {
  nodeId: string
  selected?: boolean
  dragging?: boolean
}

export function UploadMediaNodeToolbar({
  nodeId,
  selected,
  dragging,
}: UploadMediaNodeToolbarProps) {
  const [removeOpen, setRemoveOpen] = useState(false)
  const {
    handleAddToChat,
    handleSaveToLibrary,
    handleDuplicate,
    handleDelete,
  } = useNodeActions({ nodeId })

  const toolbarActions: ToolbarAction[] = useMemo(
    () => [
      {
        key: 'add-to-chat',
        label: 'Add to chat',
        icon: <MessageSquarePlus className="h-4 w-4" />,
        onClick: handleAddToChat,
      },
      {
        key: 'save-to-library',
        label: 'Save to library',
        icon: <BookmarkPlus className="h-4 w-4" />,
        onClick: handleSaveToLibrary,
      },
      {
        key: 'duplicate',
        label: 'Duplicate',
        icon: <Copy className="h-4 w-4" />,
        onClick: handleDuplicate,
        group: true,
      },
      {
        key: 'remove',
        label: 'Remove',
        icon: <Trash2 className="h-4 w-4" />,
        onClick: () => setRemoveOpen(true),
        variant: 'danger',
      },
    ],
    [handleAddToChat, handleSaveToLibrary, handleDuplicate],
  )

  return (
    <>
      <AgentNodeToolbar actions={toolbarActions} isVisible={!!selected && !dragging} />
      <RemoveNodeConfirmationModal
        isOpen={removeOpen}
        onCancel={() => setRemoveOpen(false)}
        onConfirm={() => {
          setRemoveOpen(false)
          handleDelete()
        }}
      />
    </>
  )
}
